import React from 'react';

interface UpsellStickyCtaProps {
  onNavigate: (page: string) => void;
}

export const UpsellStickyCta: React.FC<UpsellStickyCtaProps> = ({ onNavigate }) => {
  return (
    <div className="sticky-cta">
      <div className="flex items-center justify-between gap-4">
        <span className="text-sm font-semibold text-slate-900 dark:text-white">
          Upgrade to Reader — $6.99/mo
        </span>
        <button
          onClick={() => onNavigate('/signup')}
          className="px-6 py-2 text-sm font-semibold text-white bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full hover:from-blue-700 hover:to-indigo-700 transition-all whitespace-nowrap"
        >
          Get Started
        </button>
      </div>
    </div>
  );
};
